module.exports = __webpack_public_path__ + "img/none_exe.21bfe84f.png";